<app-detail-main-template>
  <div container-header>
    <app-detail-header-template>
      <div top-left>
        <div class="back-btn-container">
          <app-back-button></app-back-button>
        </div>
        <h3 class="title-container bold">{{serviceOrgText | uppercase}}</h3>
      </div>
    </app-detail-header-template>
    <div class="sub-menu__container--service-org-config">
      <div class="item">
        <a class="link"
           [ngClass]="{'active': selectedTab === 'serviceOrganization'}"
           (click)="toggleTab('serviceOrganization')">
          <div class="button">
            <div class="description">Service Organization</div>
          </div>
        </a>
      </div>
      <div class="item">
        <a class="link"
           [ngClass]="{'active': selectedTab === 'group'}"
           (click)="toggleTab('group')">
          <div class="button">
            <div class="description">Group</div>
          </div>
        </a>
      </div>
      <div class="item">
        <a class="link"
           [ngClass]="selectedTabs('providerEmails')"
           (click)="toggleTab('providerEmails')">
          <div class="button">
            <div class="description">Provider Emails</div>
          </div>
        </a>
      </div>
      <div class="item">
        <a class="link"
           [ngClass]="selectedTabs('pendCodeManager')"
           (click)="toggleTab('pendCodeManager')">
          <div class="button">
            <div class="description">Pend Code Manager</div>
          </div>
        </a>
      </div>
      <div class="item">
        <a class="link"
           [ngClass]="selectedTabs('tagManager')"
           (click)="toggleTab('tagManager')">
          <div class="button">
            <div class="description">Tag Manager</div>
          </div>
        </a>
      </div>
      <div class="item">
        <a class="link"
           [ngClass]="selectedTabs('viewManager')"
           (click)="toggleTab('viewManager')">
          <div class="button">
            <div class="description">View Manager</div>
          </div>
        </a>
      </div>
      <div class="item">
        <a class="link"
           [ngClass]="selectedTabs('dxCodeManager')"
           (click)="toggleTab('dxCodeManager')">
          <div class="button">
            <div class="description">Dx Code Manager</div>
          </div>
        </a>
      </div>
      <div class="item">
        <a class="link"
           [ngClass]="selectedTabs('documentRouting')"
           (click)="toggleTab('documentRouting')">
          <div class="button">
            <div class="description">Document Routing</div>
          </div>
        </a>
      </div>
      <div class="item" *ngIf="isOrganizationEnabledToDisplaySingleSignOnSettings" >
        <a class="link"
           [ngClass]="selectedTabs('sso')"
           (click)="toggleTab('sso')">
          <div class="button">
            <div class="description">Single Sign-On</div>
          </div>
        </a>
      </div>
    </div>
  </div>
  <div container-body class="container-set">
    <div class="serviceOrgdetails section tabContent"
         *ngIf="this.selectedTab === 'serviceOrganization'">
      <div class="information">
        <div class="service-org-config__contact-info-container">
          <h3>CONTACT INFORMATION</h3>
          <div class="form-container logo-container-wrap">
            <label class="service-org-label">Company Logo<app-tool-tip [text]="logoTooltip"></app-tool-tip></label>
            <div class="logo-container">
              <span *ngIf="!hasLogo; else image" class="logo-container__text">Logo Preview</span>
              <ng-template #image><img class="logo-container__image" [attr.src]="logoUrl"/></ng-template>
            </div>
            <div class="file-container">
              <div class="file-upload-container"><span [ngClass]="fileUploadLabel">{{fileName}}</span></div>
              <div class="file-upload-sub-container">
                <p-fileUpload #fileUpload (onSelect)="onFileSelect($event)" (onRemove)="onFileRemove()" accept=".png" [multiple]="false" chooseLabel="Browse" [showUploadButton]="false" [showCancelButton]="false">
                </p-fileUpload>
              </div>
            </div>
            <div class="p-fileupload-row" *ngIf="isServiceOrgLogoAvailable">
              <div class="file-name-container">{{fileName}}</div>
              <div>{{size}}</div>
              <div class="delete-btn">
                <app-button class="remove-button"
                            icon="times"
                            (onClick)="onFileDelete(fileName)">
                </app-button>
              </div>

            </div>
          </div>
          <div class="form-container">
            <form-factory *ngFor="let model of serviceOrgInputs; trackBy: trackByIndex" [formGroup]="serviceOrgForm"
                          [model]="model"></form-factory>
          </div>
          <div class="form-container">
            <form-factory *ngFor="let model of contactDataInputs; trackBy: trackByIndex" [formGroup]="contactDataForm"
                          [model]="model"  (onClick)="onValidateButtonClick($event)"></form-factory>
          </div>
          <div class="max-chase-count-input">
            <form-factory [formGroup]="organizationAttributeDataForm"
                          [model]="dailyMaxChaseCount"></form-factory>
          </div>
          <div class="max-chase-count-input">
            <form-factory [formGroup]="organizationAttributeDataForm"
                          [model]="maxChaseCount"></form-factory>
          </div>
          <div class="service-org-config__input-container">
            <form-factory [formGroup]="organizationAttributeDataForm"
                          [model]="reviewPagesOfChartInput"></form-factory>
          </div>
          <div class="service-org-config__input-container">
            <form-factory [formGroup]="organizationAttributeDataForm"
                          [model]="multiFactorAuthenticationInput"></form-factory>
          </div>
          <div class="service-org-config__input-container">
            <form-factory [formGroup]="organizationAttributeDataForm"
                          [model]="persistAIDAssignmentInput"></form-factory>
          </div>
           <div class="service-org-config__input-container">
            <form-factory [formGroup]="organizationAttributeDataForm"
                          [model]="includeChartSiteIdInput"></form-factory>
          </div>
        </div>
        <div class="save-button-container text-right">
          <app-button class="header-button" text="SAVE" (onClick)="saveServiceOrgConfiguration()" [disabled]="disabledProperty"></app-button>
        </div>
      </div>
      <app-modal class="add-group__modal" header="ATTENTION" [(visible)]="showCallerIdPopup"
        (onCancel)="cancelCallerIdPopup()">
        {{customCallerIdDescription}}
        <footer class="text-center">
          <app-button text="Yes" (onClick)="showVerificationCode()">
          </app-button>
        </footer>
      </app-modal>
    </div>
    <div class="clientdetails section tabContent"
         *ngIf="this.selectedTab === 'group'">
      <div class="right text-right">
        <app-button class="header-button" text="Add New Group" (onClick)="addNewGroup()"></app-button>
      </div>
      <br />
      <app-server-grid [configuration]="groupGridConfiguration"
                       [(request)]="groupGridRequest"
                       [refresh]="gridRefresh"
                       [actionTemplate]="groupActionTemplate">
        <ng-template #groupActionTemplate
                     let-rowData let-localActionPopover="actionPopover">
          <div class="action-template-container">
            <app-button *ngFor="let actionItem of groupActionItems; trackBy: trackByIndex"
                        [text]="actionItem.actionText"
                        (onClick)="groupGridActions(rowData); localActionPopover.hide();"></app-button>
          </div>
        </ng-template>
      </app-server-grid>
    </div>

    <div class="providerEmails section tabContent"
         *ngIf=" selectedTabs('providerEmails')">
      <div class="information">
        <div class="service-org-config__contact-info-container">
          <div class="provider-aging-toggle">
            <form-factory [formGroup]="providerEmailForm"
            [model]="providerAgingToggleInput"></form-factory>
            <div class="aging_description">
              {{providerAgingDescription}}
              <app-button class="sample-button" text="Preview sample" (onClick)="showProviderAgingSample()"></app-button>
            </div>
          </div>
          <div class="provider-aging-toggle">
            <form-factory [formGroup]="providerEmailForm"
            [model]="automatedOutreachToggleInput"></form-factory>
            <div class="aging_description">
              {{automatedOutreachDescription}}
            </div>
          </div>
          <div class="p-col-12 p-md-12 p-lg-12" *ngIf="isAutomaticOutreachEnabled">
            <div class="p-col-4 p-md-12 p-lg-4">
              <form-factory [formGroup]="providerEmailForm"
                            [model]="daysBeforeOverdueInput">
                          </form-factory>
              <form-factory [formGroup]="providerEmailForm"
                            [model]="daysBeforeNextCallInput">
                          </form-factory>
            </div>
          </div>
          <h3>Customize Provider Email</h3>
          <div class="form-container--extended">
            <form-factory [formGroup]="providerEmailForm"
                          [model]="emailSubjectInput"></form-factory>

            <div class="email-body__header bold">Email Body:</div>
            <div [formGroup]="providerEmailForm">
              <p-editor formControlName="emailBody" class="email-body__container">
                <p-header>
                  <span class="ql-formats">
                    <select class="ql-header">
                      <option value="1">Heading</option>
                      <option value="2">Subheading</option>
                      <option selected>Normal</option>
                    </select>
                  </span>
                  <span class="ql-formats">
                    <button class="ql-bold"
                            aria-label="1"></button>
                    <button class="ql-italic"
                            aria-label="Italic"></button>
                    <button class="ql-underline"
                            aria-label="Underline"></button>
                  </span>
                  <span class="ql-formats">
                    <select class="ql-align">
                      <option selected></option>
                      <option value="center"></option>
                      <option value="right"></option>
                      <option value="justify"></option>
                    </select>
                  </span>
                </p-header>
              </p-editor>
            </div>

          </div>
        </div>
        <div class="save-button-container text-right">
          <app-button class="header-button" text="SAVE" (onClick)="saveServiceOrgConfiguration()"  [disabled]="disabledProviderEmail"></app-button>
        </div>
      </div>
    </div>

    <div class="tagManager section tabContent"
         *ngIf=" selectedTabs('tagManager')">
      <div class="information">
        <div class="service-org-config__contact-info-container">
          <div class="tab-header-section" top-left>
            <div class="tab-header-section__title set-tag-header">Tag Manager</div>
            <div class="tab-header-section__description tag-content">
              Here's a list of your Tags. All Tags have been categorized for your convenience.
            </div>
          </div>
          <div class="service-org-config__input-container setList">
            <div class="p-md-3 tab-list-container">
              <div *ngFor="let type of dashboardTagCount; let i = index; trackBy: trackByFn; let first= first;" class="first all-count">
                <div class="tab-category"
                     [ngClass]="selectedTagType(type.tagTypeName, true, null)"
                     (click)="setTagType(type.tagTypeId,type.tagTypeName)">
                  <span class="set-type-name">{{type.tagTypeName}}</span>
                  <span class="count"> {{type.tagCount}}</span>
                </div>


                <ul class="category__label">
                  <li *ngFor="let tag of type.tagDashboardCount; let i = index; trackBy: trackByFn"
                      [class]="getClass(tag.tagTypeName)"
                      [ngClass]="selectedTagType(type.tagTypeName, false, tag.tagTypeName)"
                      (click)="setTagType(tag.tagTypeId,tag.tagTypeName)">
                    <span class="setposition">
                      {{tag.tagTypeName}}
                    </span>
                    <span class="count"> {{tag.tagCount}}</span>
                  </li>

                </ul>
              </div>
              <div (click)="createNewTag()" class="addTag-icon">
                <app-icon [iconName]="getTagIcon()" [iconStyle]="getTagIcon()"></app-icon>
                <span class="addTag_label">Create New Tag</span>
              </div>
            </div>

            <div class="p-md-6 tag-list-container">
              <div *ngFor="let type of tagGridRequest; let i = index; trackBy: trackByFn;" class="tag-list-container__item">
                <div class="outer">
                  <div class="tag-icon-container">

                    <div class="tag_item" [ngClass]="getClassIcon(type)">
                      <app-icon [iconName]="getIcon(type)"
                                [iconStyle]="getIcon(type)"></app-icon>
                    </div>

                  </div>

                  <div class="tag-item-container__content">
                    <div class="tag-item-container--direction">
                      <span title='{{type.tagText}}' class="tag-item-container--name">{{type.tagText}}</span>
                      <span class="tag-item-container--description">Total {{setCountHeader(type.tagTypeId)}}: {{type.totalObject}}</span>
                    </div>
                  </div>
                </div>
                <label class="new_label">Tag color:</label><span class="dot" [ngStyle]="{'background-color':type.color}"></span>
                <div class="setAction">
                  <div (click)="popover.toggle($event)" class="fas fa-ellipsis-v ui-clickable p-button-icon-left"></div>

                  <app-popover-tag appendTo="body" #popover [isPinned]="false">

                    <div class="action-template-container tag-action">
                      <app-button *ngFor="let action of actions; trackBy: trackByIndex"
                                  [text]="action.name"
                                  (onClick)="action.action(type);popover.hide();"
                                  [disabled]="action.disabled"></app-button>
                    </div>

                  </app-popover-tag>

                </div>

              </div>

            </div>

            <div class="p-md-3 search-section">
              <div class="search-section__input">
                <form-factory [formGroup]="searchPhraseForm"
                              [model]="searchPhraseInput"
                              (onInput)="onInputSearchText()"
                              (keyup.enter)="fetchTextMatches()">
                </form-factory>

              </div>
              <app-button *ngIf="isShowSearchIcon"
                          class="search-bar__item search-bar__item--icon search-bar__item--search-icon"
                          classes="transparent small"
                          icon="play fa-search"
                          (onClick)="fetchTextMatches(searchResults)">
              </app-button>
              <app-button *ngIf="!isShowSearchIcon"
                          class="search-bar__item search-bar__item--icon search-bar__item--search-icon"
                          classes="transparent small"
                          icon="times-circle"
                          (onClick)="resetSearchInput()">
              </app-button>
            </div>

            <div class="p-md-12" *ngIf="checkCount">

              <app-pagination *ngIf="this.showPagination" 
              [rows]="rows" 
              [totalRecords]="totalRecords"
              (onPageChange)="onPageChange($event)">
            </app-pagination>

            </div>
          </div>


        </div>

      </div>


      <app-tag-manage [(visible)]="isManageTagModalVisible"
                      [entityName]="entityName"
                      [createTag]="isCreateTag"
                      [editTag]="isEditTags"
                      [tagAction]="tagAction"
                      [editTagObj]="editTagObj"
                      [deleteTag]="isDeleteTag"
                      [headerSet]="headerSet"
                      [replaceTag]="isReplaceTag"
                      (tagGridUpdate)="tagGridUpdate()">
      </app-tag-manage>
    </div>

    <div class="pendCodeManager section tabContent"
         *ngIf=" selectedTabs('pendCodeManager')">
      <div class="information">
        <div class="service-org-config__contact-info-container">
          <div class="tab-header-section" top-left>
            <div class="tab-header-section__title set-pend-code-header">MANAGE PEND CODES</div>
            <div class="tab-header-section__description pend-content">
              The Pend Code Manager allows you to show and hide Pend Codes within your Service Organization. You can also create custom Pend Codes.
            </div>
          </div>
          <div class="service-org-config__input-container setList">

            <div class="p-md-6 pend-tab-list-container">
              <label class="pend-code-label pend-header">Pend Code Categories</label>
              <div class="first all-count">
                <ul class="pend-category-label">
                  <li *ngFor="let pendType of dashboardPendCodeCount; let i = index; trackBy: trackByFn"
                      [ngClass]="selectedPendType(pendType.pendTypeCategoryId)"
                      (click)="getPendCodes(pendType.pendTypeCategoryId)">
                    <span class="pend-category-position">
                      {{pendType.pendTypeCategory}}
                    </span>
                    <span class="count"> {{pendType.pendCount}}</span>
                  </li>

                </ul>
              </div>
              <div (click)="createNewPendCode()" class="addPendCode-icon">
                <app-icon [iconName]="getPendCodeIcon()" [iconStyle]="getPendCodeIcon()"></app-icon>
                <span class="addPenCode_label">Create New Pend Code</span>
              </div>
            </div>

            <div class="p-md-6 tag-list-container pend-list-position pend-code-manager-tab-content">

              <div class="p-col-12 p-md-12 p-lg-12 pend-codes" *ngIf="isAllPendCodes">                
                <div class="pend-code-label">ALL PEND CODES</div>
              </div>
              <div class="p-col-12 p-md-12 p-lg-12 pend-codes" *ngIf="isClinical">
                <div class="pend-code-label">Clinical Pend Codes<span><app-tool-tip [text]="clinicalPendCodeMessage"></app-tool-tip></span></div>
                <div class="pend-code-position">
                  <form-factory [formGroup]="pendCodeManagerForm" [model]="clinicalCodesInput"></form-factory>
                </div>
              </div>
              <div class="p-col-12 p-md-12 p-lg-12 pend-codes" *ngIf="is4DigitPendCodes">
                <div class="pend-code-label">4-Digit Pend Codes: Codes used to Close Chases<span><app-tool-tip [text]="fourDigitPendCodeMessage"></app-tool-tip></span></div>
                <div class="pend-code-position">
                  <form-factory [formGroup]="pendCodeManagerForm" [model]="digitPendCodesInput"></form-factory>
                </div>
              </div>
              <div class="p-col-12 p-md-12 p-lg-12 pend-codes" *ngIf="isCodesDataLoads">
                <div class="pend-code-label">Codes used during Data Loads</div>
                <div class="pend-code-position">
                  <form-factory [formGroup]="pendCodeManagerForm" [model]="codesDataLoadsInput"></form-factory>
                </div>
              </div>
              <div class="p-col-12 p-md-12 p-lg-12 pend-codes" *ngIf="isCustomPendCodes">
                <div class="pend-code-label">Custom Created Codes</div>
                <div class="pend-code-position pendCode" *ngIf="hasCustomPendCodes">
                  <form-factory [formGroup]="pendCodeManagerForm" [model]="customCreatedCodesInput" (onChange)="onChange($event)"></form-factory>
                </div>
                <span class="noPendCustomCode" *ngIf="!hasCustomPendCodes">You haven't created any Pend Codes.</span>
              </div>
              <div class="p-col-12 p-md-12 p-lg-12 pend-codes" *ngIf="isFailureMedicalRecords">
                <div class="pend-code-label">Failure to Locate Medical Records</div>
                <div class="pend-code-position">
                  <form-factory [formGroup]="pendCodeManagerForm" [model]="medicalRecordsInput"></form-factory>
                </div>
              </div>
              <div class="p-col-12 p-md-12 p-lg-12 pend-codes" *ngIf="isGeneralCodes">
                <div class="pend-code-label">General Pend Codes</div>
                <div class="pend-code-position">
                  <form-factory [formGroup]="pendCodeManagerForm" [model]="generalCodesInput"></form-factory>
                </div>
              </div>
              <div class="p-col-12 p-md-12 p-lg-12 pend-codes" *ngIf="isMemberCentric">
                <div class="pend-code-label">HEDIS Member Centric Specific</div>
                <div class="pend-code-position">
                  <form-factory [formGroup]="pendCodeManagerForm" [model]="memberCentricInput"></form-factory>
                </div>
              </div>
              <div class="p-col-12 p-md-12 p-lg-12 pend-codes" *ngIf="isIVARisk">
                <div class="pend-code-label">IVA / Risk Specific Pend Codes</div>
                <div class="pend-code-position">
                  <form-factory [formGroup]="pendCodeManagerForm" [model]="iVARiskSpecificInput"></form-factory>
                </div>
              </div>
              <div class="p-col-12 p-md-12 p-lg-12 pend-codes" *ngIf="isProviderIndicates">
                <div class="pend-code-label">Provider Response Indicates they Cannot Retrieve</div>
                <div class="pend-code-position">
                  <form-factory [formGroup]="pendCodeManagerForm" [model]="providerIndicatesCannotRetrieveInput"></form-factory>
                </div>
              </div>
              <div class="p-col-12 p-md-12 p-lg-12 pend-codes" *ngIf="isRefusalRequestRejected">
                <div class="pend-code-label">Refusal/Request Rejected</div>
                <div class="pend-code-position">
                  <form-factory [formGroup]="pendCodeManagerForm" [model]="requestRejectedInput"></form-factory>
                </div>
              </div>
            </div>
          </div>


        </div>
        <div class="save-button-container text-right pend-save-button">
          <app-button class="header-button" text="SAVE" (onClick)="savePendCode()"></app-button>
        </div>
      </div>
      <app-create-new-pend-modal [(visible)]="isPendModalVisible"
                                 [isEditPendCode]="isEditPendCode"
                                 [pendCodeTypeId]="pendCodeTypeId"
                                 (pendCodeCategoryListUpdate)="pendCodeCategoryListUpdate()"
                                 >
      </app-create-new-pend-modal>
    </div>

    <div class="section tabContent" *ngIf=" selectedTabs('dxCodeManager')">
      <serviceorg-config-dx-code-manager></serviceorg-config-dx-code-manager>
    </div>
    <div class="section tabContent" *ngIf=" selectedTabs('viewManager')">
     <serviceorg-config-view-manager></serviceorg-config-view-manager>
    </div>

    <div class="documentRouting section tabContent"
         *ngIf=" selectedTabs('documentRouting')">
         <div class="information">
          <div class="service-org-config__contact-info-container">
            <div class="tab-header-section" top-left>
              <div class="tab-header-section__title set-pend-code-header document-routing-header">Document Routing Automation Settings</div>
              <div class="tab-header-section__description pend-content document-routing-subheader">
                When documents are uploaded and not assigned to a chase, you can take advantage of our document routing automation. This automated process attaches documents to <br> chases without manual intervention. Below are the following document ingestion methods available for document routing. If disabled, documents will go directly to document intake.
              </div>
            </div>
            <div class="service-org-config__input-container setList">
  
              <div class="p-md-6 document-routing-margin">
                  <div class="document-routing-toggle">
                  <label class="service-org-label">Bulk Upload</label>
                  <form-factory [formGroup]="documentRoutingForm" [model]="documentRoutingBulkUploadToggleInput"
                  (onChange)="updateDocumentRouting($event, 'BulkUpload')"></form-factory>
                </div>
                <div class="document-routing-toggle">
                <label class="service-org-label">Fax</label>
                <form-factory [formGroup]="documentRoutingForm" [model]="documentRoutingFaxToggleInput"
                (onChange)="updateDocumentRouting($event, 'Fax')"></form-factory>
              </div>
              <div class="document-routing-toggle">
              <label class="service-org-label">FTP</label>
              <form-factory [formGroup]="documentRoutingForm" [model]="documentRoutingFTPToggleInput"
              (onChange)="updateDocumentRouting($event, 'FTP')"></form-factory>
            </div>
            <div class="document-routing-toggle">
            <label class="service-org-label">Mail</label>
            <form-factory [formGroup]="documentRoutingForm" [model]="documentRoutingMailToggleInput"
            (onChange)="updateDocumentRouting($event, 'Mail')"></form-factory>
          </div>
          <div class="document-routing-toggle">
            <label class="service-org-label">Provider Gateway</label>
            <form-factory [formGroup]="documentRoutingForm" [model]="documentRoutingProviderGatewayInput"
            (onChange)="updateDocumentRouting($event, 'ProviderEmail')"></form-factory>
          </div>
              </div>
            </div>
  
  
          </div>
        </div>
        <app-modal class="add-group__modal"
            header="ATTENTION"
           [(visible)]="showDocumentRoutingPopup"
           (onCancel)="cancelDocumentRouting()">
           {{documentRoutingDescription}}
            <footer class="text-center">
              <app-button text="Yes"
                          (onClick)="confirmDocumentRouting()">
              </app-button>
            </footer>

        </app-modal>
    </div>

    <div class="sso section tabContent"
         *ngIf="selectedTabs('sso')">
         <div class="information">
          <div class="service-org-config__contact-info-container">
            <div class="tab-header-section" top-left>
              <div class="tab-header-section__title set-pend-code-header document-routing-header">Enable SSO</div>
              <div class="tab-header-section__description pend-content document-routing-subheader">
                <form-factory [formGroup]="ssoInputsForm" [model]="ssoToggleInput"
                  (onChange)="enableSso($event)"></form-factory>
              </div>
            </div>
             <div class="tab-header-section"  *ngIf="isSsoEnabled" top-left>
              <div class="tab-header-section__title set-pend-code-header document-routing-header">Select Single Sign-On Version</div>
              <div class="tab-header-section__description pend-content document-routing-subheader">
                <form-factory [formGroup]="ssoInputsForm" [model]="ssoOptionInput" (onChange)="onSSOOptionChange($event)" ></form-factory>
              </div>
            </div>
            <div class="p-md-6 document-routing-margin sso" *ngIf="isLegacySSOSelected">
              <div>
                <form-factory [formGroup]="ssoConfigForm" [model]="indentityProviderInput"></form-factory>
              </div>
              <div>
                <form-factory [formGroup]="ssoConfigForm" [model]="applicationIdInput"></form-factory>
              </div>
              <div>
                <form-factory [formGroup]="ssoConfigForm" [model]="directoryIdInput"></form-factory>
              </div>
              <div class="domain" >
                <div class="domain__label">
                  <label>DOMAIN(S)</label>
                </div>
                <div class="domain__controls">
                  <div *ngFor="let item of ssoDomainForm.get('Domain').controls; let i=index; trackBy: trackByIndex"
                      [formGroup]="item">
                  <div class="milestone-weekly-item">
                    <input formControlName="Domains" class="input request-timeline-input" placeholder="Ex: reveleer.com">
                    
                    <div *ngIf="isRemoveIconVisible(ssoDomainForm.get('Domain').controls, i)" (click)="ssoDomainForm.get('Domain').removeAt(i)">
                      <app-button class="btn-remove" [ngClass]="getRemoveIcon()"> </app-button>
                    </div>
                    <div class="add-btn" (click)="ssoDomainForm.get('Domain').push(buildDynamicListOfDomains(Domains))">
                      <div [ngClass]="getClassForPlusIcon()">
                        <app-icon [iconName]="getTagIcon()" [iconStyle]="getTagIcon()"></app-icon>
                      </div>
                      <app-button class="header-button btn-add-request"
                                  styleClass="request-line-lettercase">
                                  <div [ngClass]="getClassForPlusIcon()">
                                    <app-icon [iconName]="getTagIcon()" [iconStyle]="getTagIcon()"></app-icon>
                                  </div>
                      </app-button>
                    </div>
                  </div>
                </div>
                </div>
              </div>
              
            </div>
            <div class="save-button-container text-right">
              <app-button class="header-button" text="SAVE" (onClick)="saveSSOSettings()"></app-button>
            </div>
          </div>
        </div>
    </div>

  </div>

</app-detail-main-template>

<app-modal [(visible)]="isGroupModalVisible"
           header="{{groupModalHeader | uppercase}}"
           class="add-group__modal">
  <form [formGroup]="groupForm">
    <div class="information">
      <div class="service-org-config__contact-info-container">
        <div class="service-org-config__input-container">
          <form-factory *ngFor="let model of groupNameInputs; trackBy: trackByIndex" [formGroup]="groupForm"
                        [model]="model"></form-factory>
        </div>
      </div>
    </div>
  </form>
  <footer>
    <app-button class="header-button"
                text="{{groupAction | uppercase}}"
                (onClick)="saveGroupName()"></app-button>
  </footer>
</app-modal>

<div class="sample-modal">
  <app-confirmation-modal [(visible)]="isProviderAgingSampleModelVisible" header=""
           class="add-group__modal samplePreview" rejectText="Close">
  <div><img class="sample-image" [attr.src]="providerAgingSampleImageUrl" alt="sample-image"/></div>
  </app-confirmation-modal>
</div>
